import { adapts, AzureBlobFSStoreReadSettingsAdapter } from 'app/model/adapters/activities/copysource/store-read-settings/azure-blob-fs-store-read-settings.adapter';
import { AdapterRegistry, Metamodel } from 'shell-models-lib';
import { OneLakeFilesReadSettings } from 'app/model/pipeline/copysource/store-read-settings/one-lake-file-read-settings';

@AdapterRegistry.adapter({ model: Metamodel.modelFor(OneLakeFilesReadSettings), asynchronous: true, adapts })
export class OneLakeFileReadSettingsAdapter extends AzureBlobFSStoreReadSettingsAdapter {}
